import { Routes } from '@angular/router';
//import { TppComplete } from './components/tpp/tpp-complete/tpp-complete';
//import { TppInstructions } from './components/tpp/tpp-instructions/tpp-instructions';
//import { TppClaimants } from './components/tpp/tpp-claimants/tpp-claimants';
import { Home } from './components/home/home';
//import { ConsumerClaimants } from './components/consumer/consumer-claimants/consumer-claimants';
//import { ConsumerComplete } from './components/consumer/consumer-complete/consumer-complete';
//import { ConsumerInstructions } from './components/consumer/consumer-instructions/consumer-instructions';

export const routes: Routes = [

  { path: '', component: Home },   // ✅ Home loads first
  { path: 'home', component: Home },

  //{ path: 'tpp-instructions', component: TppInstructions },
  //{ path: 'tpp-claimants', component: TppClaimants },
  //{ path: 'tpp-complete', component: TppComplete },

  //{ path: 'consumer-instructions', component: ConsumerInstructions },
  //{ path: 'consumer-claimants', component: ConsumerClaimants },
  //{ path: 'consumer-complete', component: ConsumerComplete },


  { path: '**', redirectTo: '' }

  //{ path: '', pathMatch: 'full', redirectTo: 'tpp-instructions' },
  //{ path: 'tpp-instructions', component: TppInstructions },
  //{ path: 'tpp-claimants', component: TppClaimants },
  //{ path: 'tpp-complete', component: TppComplete },
  //{ path: 'home', component: Home },
  //{ path: '**', redirectTo: 'tpp-instructions' },

];
